// The Spec section of an item's side panel (ERP-PLAN.md §5.11): the spec narrow, and its full editor as the next level
// of the side pane, which shows one level at a time (one editor at a time, so edits never race each other).
import type { Item } from "../../../../shared/db.gen.ts";
import { paneBackTo, usePane, usePaneLevel, usePaneOpen } from "../../ui/SidePane.tsx";
import { useSpecIndex } from "./lib.ts";
import { NoSpec, SpecWorkspace } from "./SpecWorkspace.tsx";

/** `hideEmpty`: an item bought finished shows no "No spec yet". */
export function SpecSection({ item, hideEmpty = false }: { item: Item; hideEmpty?: boolean }) {
  const ix = useSpecIndex();
  const paneOpen = usePaneOpen();
  const trail = usePane();
  const level = usePaneLevel();
  const spec = ix.specByItem.get(item.id);
  if (!spec && hideEmpty) return null;
  // Opened from its own spec ("Open item"): the full editor is the level before, so go back to it
  const below = level ? trail[level - 1] : undefined;
  const expand = below?.kind === "spec" && below.id === item.id ? () => paneBackTo(level ?? 0) : () => paneOpen("spec", item.id);
  return (
    <section className="mt-3 border-t border-line pt-2">
      <div className="flex items-center gap-2 px-2 pb-1">
        <h3 className="text-[11px] font-medium tracking-wide text-faint uppercase">Spec</h3>
      </div>
      {!spec ? <NoSpec item={item} /> : <SpecWorkspace key={spec.id} item={item} spec={spec} ix={ix} onExpand={expand} />}
    </section>
  );
}
